import { IMAGES } from "@/lib/contact";

const ITEMS = [
  { text: "Bármilyen méretű kanapé, sarokgarnitúra, ágy szétzerelése és elszállítása", cap: "Szétszerelés helyben", alt: "Szerelő akkus fúróval bútort szerel szét" },
  { text: "Nehéz, kiülőlt matracok és fotelek mentesítése", cap: "Matrac és fotel", alt: "Férfi matracot visz" },
  { text: "Hivatalos leadás és környezetbarát ártalmatlanítás", cap: "Hivatalos leadóhely", alt: "Rendezett, modern raktárcsarnok teherautókkal" },
];

const Photo = ({ src, cap, alt }) => (
  <figure className="relative aspect-[4/3] m-0 bg-steel overflow-hidden">
    <img src={src} alt={alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
    <figcaption className="lb absolute left-6 bottom-6 bg-white text-slatetext px-2 py-1">{cap}</figcaption>
  </figure>
);

const Text = ({ text, idx }) => (
  <div data-testid={`service-${idx + 1}`} className="p-8 md:p-12 flex items-center min-w-0 bg-white text-ink">
    <p className="mo text-2xl">{text}</p>
  </div>
);

export const Services = () => (
  <section id="szolgaltatasok" data-testid="services-section" className="bg-ground text-ink">
    <h2 className="mo px-6 pt-24 md:pt-32 pb-12">Szolgáltatások</h2>
    <div className="grid md:grid-cols-2">
      {ITEMS.map((it, i) => {
        const photo = <Photo key={`p${i}`} src={IMAGES.services[i]} cap={it.cap} alt={it.alt} />;
        const text = <Text key={`t${i}`} text={it.text} idx={i} />;
        return i % 2 === 1 ? [text, photo] : [photo, text];
      })}
    </div>
  </section>
);
